import React, { useEffect, useRef, useState } from 'react'
import { ArrowBackIcon } from '@chakra-ui/icons'
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,
  Flex,
  FormControl,
  Image,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  useDisclosure,
  useMediaQuery,
  VStack
} from '@chakra-ui/react'
import { Link, useNavigate } from 'react-router-dom'
import LogoutHeader from '../../components/LogoutHeader'
import useBottler from '../../hooks/useBottler'
import clientAxios from '../../config/axios'
import { Toaster, toast } from 'react-hot-toast'
import LoadingComponents from '../../components/LoadingComponents'

const quilmesImages = require.context('../../assets/images', true)

const BottlerManagement = () => {
  const [bottler] = useBottler()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [openCreate, setOpenCreate] = useState(false)
  const [openEdit, setOpenEdit] = useState(false)
  const [bottlerId, setBottlerId] = useState('')
  const [success, setSuccess] = useState('')
  const [successId, setSuccessId] = useState('')
  const [bottlerName, setBottlerName] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [size, setSize] = useState('full')
  const cancelRef = useRef()
  const initialRef = React.useRef(null)
  const finalRef = React.useRef(null)
  const [isLargerThan768] = useMediaQuery('(min-width: 780px)')
  const navigate = useNavigate()

  useEffect(() => {
    if (bottler.length === 0) {
      setLoading(true)
    } else {
      setLoading(false)
    }
  }, [bottler])

  if (loading) {
    return (
      <LoadingComponents loading={loading} />
    )
  }

  const onCloseCreate = () => {
    setOpenCreate(false)
  }

  const onCloseEdit = () => {
    setOpenEdit(false)
  }

  const handleSubmitCreate = (e) => {
    e.preventDefault()
    const nameSpace = /^\S.*\S$/

    if (bottlerName === '') {
      setError('El campo no puede estar vacío.')

      return
    }

    if (!nameSpace.test(bottlerName)) {
      setError('El nombre no puede contener espacios al inicio o al final.')

      return
    }

    if (error === '') {
      clientAxios.post('/bottler', {
        description: bottlerName
      })
        .then(res => {
          console.log(res.data)
          setSuccess('¡Listo! Se creó la embotelladora')
          setSuccessId(bottlerName)
          onCloseCreate()

          setTimeout(() => {
            navigate(0)
          }, 1000)
        })
        .catch(err => {
          if (err.response.data.statusCode === 400) {
            setError('Ya existe una embotelladora con este nombre.')

            return
          }
          onCloseCreate()
        })
    }

    setTimeout(() => {
      setSuccess('')
      setSuccessId('')
    }
    , 1000)
  }

  const handleSubmitEdit = (e) => {
    e.preventDefault()
    const nameSpace = /^\S.*\S$/

    if (bottlerName === '') {
      setError('El campo no puede estar vacío.')

      return
    }

    if (!nameSpace.test(bottlerName)) {
      setError('El nombre no puede contener espacios al inicio o al final.')

      return
    }

    if (error === '') {
      clientAxios.put(`/bottler/${bottlerId}`, {
        description: bottlerName
      })
        .then(res => {
          setSuccess('¡Listo! Se actualizó la embotelladora')
          setSuccessId(bottlerName)
          onCloseEdit()

          setTimeout(() => {
            navigate(0)
          }, 1000)
        })
        .catch(err => {
          if (err.response.data.statusCode === 400) {
            setError('Ya existe una embotelladora con este nombre.')

            return
          }
          onCloseEdit()
        })
    }

    setTimeout(() => {
      setSuccess('')
      setSuccessId('')
    }
    , 1000)
  }

  const deleteElement = () => {
    clientAxios.delete(`/bottler/${bottlerId}`)
      .then(res => {
        setSuccess('¡Listo! Se eliminó la embotelladora')
        setSuccessId(bottlerId)
        onClose()

        setTimeout(() => {
          navigate(0)
        }, 1000)
      })
      .catch(() => {
        onClose()
      })

    setTimeout(() => {
      setSuccess('')
      setSuccessId('')
    }
    , 1000)
  }

  const obtenerDia = (date) => {
    // restar la fecha actual menos la fecha de la base de datos
    const fecha = new Date(date)
    const fechaActual = new Date()
    const resta = fechaActual - fecha
    const dias = Math.floor(resta / (1000 * 60 * 60 * 24))

    if (dias === 0) {
      return 'Modificado hoy'
    } else if (dias === 1) {
      return 'Modificado hace 1 día'
    }

    return `Modificado hace ${dias} días`
  }

  return (
    <Stack
      paddingBottom={'2rem'}
    >
      <Box
        {...(isLargerThan768
          ? { display: 'flex', justifyContent: 'space-between' }
          : { display: 'none' })}
        alignItems={'center'}
        className='logo-home'
        paddingLeft={'5%'}
        paddingRight={'5%'}
      >
        <LogoutHeader />
      </Box>

      <Stack borderBottom={' 1px solid #E1E1E1'}>
        <Box
          display={'flex'}
          flexDirection={'row'}
          justifyContent={'space-between'}
          margin={'0 auto'}
          padding={{ base: '1rem 1rem', md: '1rem 5rem' }}
          width={{ base: '90%', md: '100%' }}
        >
          <Link to={'/home'}>
            <ArrowBackIcon color={'#0A0808'} h={6} w={6} />
          </Link>
          <Text fontWeight={'bold'} paddingLeft={{ base: '0rem', md: '7rem' }}>
            Gestión de Embotelladoras
          </Text>
          <Button
            {...(!isLargerThan768
              ? { visibility: 'hidden' }
              : { visibility: 'visible' })}
            marginTop={'0rem'}
            variant={'btn-quilmes'}
            w={{ base: '15%', md: 'max-content' }}
            onClick={() => setOpenCreate(true)}
          >
            Agregar Embotelladora
          </Button>
        </Box>
      </Stack>

      <VStack
        alignItems={'center'}
        display={'flex'}
        justifyContent={'center'}
        paddingTop={{ base: '1rem', md: '2rem' }}
        width={{ base: '100%', md: '100%' }}
      >
        {bottler
          .sort((a, b) =>
            a.description.toLowerCase() < b.description.toLowerCase() ? -1 : 1
          )
          .map((item) => (
            <Box
              key={item.bottlerId}
              alignItems={'center'}
              borderBottom={' 1px solid #E1E1E1'}
              display={'flex'}
              padding={'1rem 0rem'}
              textTransform={'capitalize'}
              value={item.description}
              w={{ base: '90%', md: '40%' }}
            >
              <Box display={'flex'} flexDirection={'column'} width={'100%'}>
                <Text
                  color={'#3B3939'}
                  display={'inline-block'}
                  fontSize={'16px'}
                  fontWeight={'400'}
                  lineHeight={'22px'}
                  w={'85%'}
                >
                  {item.description}
                </Text>
                <Text
                  color={'#707070'}
                  fontSize={'10px'}
                  fontStyle={'normal'}
                  lineHeight={'14px'}
                  textTransform={'initial'}
                >
                  {item.modificationDate === null
                    ? 'Aún no se ha modificado'
                    : obtenerDia(item.modificationDate)
                  }
                </Text>
              </Box>

              <Box
                display={'flex'}
                flexDirection={'row'}
                gap={{ base: '0.5rem', md: '1rem' }}
                marginRight={{ base: '1.5rem', md: '1rem' }}
              >
                <Image
                  className='img-gestion'
                  cursor={'pointer'}
                  src={quilmesImages('./editar.svg')}
                  w={'40px'}
                  onClick={() => {
                    setBottlerId(item.bottlerId)
                    setOpenEdit(true)
                    setBottlerName(item.description)
                  }}
                />
                <Image
                  className='img-gestion'
                  cursor={'pointer'}
                  src={quilmesImages('./Eliminar.svg')}
                  w={'40px'}
                  // obtener el id de la embotelladora
                  onClick={() => {
                    setBottlerId(item.bottlerId)
                    onOpen()
                  }}
                />
              </Box>

            </Box>
          ))}
        {!isLargerThan768
          ? (
            !openEdit && !openCreate
              ? (
                <Stack
                  alignItems={'center'}
                  bg={'#F7F7F7'}
                  bottom={0}
                  justifyContent={'center'}
                  paddingBottom={'.5rem'}
                  paddingTop='1rem'
                  position={'fixed'}
                  w={'100%'}
                >
                  <Button
                    margin={0}
                    marginBottom={'1rem'}
                    type='submit'
                    variant='btn-quilmes'
                    w={'90%'}
                    onClick={() => setOpenCreate(true)}
                  >
                    Agregar Embotelladora
                  </Button>
                </Stack>
              )
              : null
          )
          : null}
      </VStack>
      {/* Modal de agregar */}
      <Modal
        isCentered
        closeOnOverlayClick={false}
        finalFocusRef={finalRef}
        initialFocusRef={initialRef}
        isOpen={openCreate}
        width={{ base: '100%', md: '100%' }}
        onClose={onCloseCreate}

      >
        <ModalOverlay />
        <ModalContent
          marginRight={{ base: '0rem', md: '3rem' }}
        >
          <VStack
            alignItems={'flex-start'}
            as={'form'}
            display={'flex'}
            justifyContent={'flex-start'}
            onSubmit={handleSubmitCreate}
          >
            <ModalHeader
              fontSize={'16px'}
              fontWeight={'700'}
            >Agregar Embotelladora</ModalHeader>
            <ModalBody>
              <FormControl
                className='floating-label-group'
                marginTop={'-.5rem'}
                paddingBottom={4}
                onFocus={() => setError('')}
              >
                <Input
                  className='input'
                  id='channel'
                  name='channel'
                  placeholder={' '}
                  type='text'
                  onChange={(e) =>
                    setBottlerName(e.target.value)
                  }
                  onFocus={() => setError('')}
                  {...(error !== '' ? { borderColor: 'red.500' } : {})}
                  _hover={{
                    ...(error !== '' ? { borderColor: 'red.500' } : {})
                  }}
                />
                <label
                  className='placeholder'
                  htmlFor='channel'
                  {...(error !== '' ? { className: 'error-input' } : {})}
                >
                  Nombre de embotelladora
                </label>

                {error && (
                <Text
                  color='red.500'
                  fontSize={'12px'}
                  paddingLeft={'.5rem'}
                  paddingTop={'1rem'}
                  w={{ base: '75%', md: '100%' }}
                >
                  {error}
                </Text>
                )}
              </FormControl>
            </ModalBody>
            <ModalFooter
              alignItems={'center'}
              display={'flex'}
              flexDirection={'row'}
              gap={'1rem'}
              justifyContent={'space-between'}
              width={'100%'}
            >
              <Button
                _active={{ bg: '#FFF' }}
                _focus={{ boxShadow: 'none' }}
                _hover={{ bg: '#FFF' }}
                bg={'#FFF'}
                border={'1px solid #DB580B'}
                color={'#DB580B'}
                marginTop={'-1rem'}
                width={'100%'}
                onClick={onCloseCreate}>Cancelar</Button>
              <Button
                marginTop={'-1rem'}
                ml={3}
                type='submit'
                variant={'btn-quilmes'}
                width={'100%'}
              >
                Agregar
              </Button>
            </ModalFooter>
          </VStack>
        </ModalContent>
      </Modal>

      {/* Modal de editar */}
      <Modal
        isCentered
        closeOnOverlayClick={false}
        finalFocusRef={finalRef}
        initialFocusRef={initialRef}
        isOpen={openEdit}
        width={{ base: '100%', md: '100%' }}
        onClose={onCloseEdit}
      >
        <ModalOverlay />
        <ModalContent
          marginRight={{ base: '0rem', md: '3rem' }}
        >
          <VStack
            alignItems={'flex-start'}
            as={'form'}
            display={'flex'}
            justifyContent={'flex-start'}
            onSubmit={handleSubmitEdit}
          >
            <ModalHeader
              fontSize={'16px'}
              fontWeight={'700'}
            >Editar embotelladora</ModalHeader>
            <ModalBody>
              <FormControl
                className='floating-label-group'
                marginTop={'-.5rem'}
                paddingBottom={4}
                onFocus={() => setError('')}
              >
                <Input
                  className='input'
                  id='channel'
                  name='channel'
                  placeholder={' '}
                  type='text'
                  value={bottlerName}
                  onChange={(e) =>
                    setBottlerName(e.target.value)
                  }
                  onFocus={() => setError('')}
                  {...(error !== '' ? { borderColor: 'red.500' } : {})}
                  _hover={{
                    ...(error !== '' ? { borderColor: 'red.500' } : {})
                  }}
                />
                <label
                  className='placeholder'
                  htmlFor='channel'
                  {...(error !== '' ? { className: 'error-input' } : {})}
                >
                  Nombre de embotelladora
                </label>

                {error && (
                <Text
                  color='red.500'
                  fontSize={'12px'}
                  paddingLeft={'.5rem'}
                  paddingTop={'1rem'}
                  w={{ base: '75%', md: '100%' }}
                >
                  {error}
                </Text>
                )}
              </FormControl>
            </ModalBody>
            <ModalFooter
              alignItems={'center'}
              display={'flex'}
              flexDirection={'row'}
              gap={'1rem'}
              justifyContent={'space-between'}
              width={'100%'}
            >
              <Button
                _active={{ bg: '#FFF' }}
                _focus={{ boxShadow: 'none' }}
                _hover={{ bg: '#FFF' }}
                bg={'#FFF'}
                border={'1px solid #DB580B'}
                color={'#DB580B'}
                marginTop={'-1rem'}
                width={'100%'}
                onClick={onCloseEdit}>Cancelar</Button>
              <Button
                marginTop={'-1rem'}
                ml={3}
                type='submit'
                variant={'btn-quilmes'}
                width={'100%'}
              >
                Guardar
              </Button>
            </ModalFooter>
          </VStack>
        </ModalContent>
      </Modal>

      {/* Modal de eliminación */}
      { isLargerThan768
        ? <AlertDialog
          isCentered
          closeOnOverlayClick={false}
          isOpen={isOpen}
          leastDestructiveRef={cancelRef}
          onClose={onClose}
        >
          <AlertDialogOverlay>
            <AlertDialogContent>
              <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                Eliminar embotelladora
              </AlertDialogHeader>

              <AlertDialogBody
                fontSize={'14px'}
                fontStyle={'normal'}
                fontWeight={'400'}
                lineHeight={'22px'}
              >
                Se eliminará esta embotelladora definitivamente.
              </AlertDialogBody>

              <AlertDialogFooter
                alignItems={'flex-start !important'}
                display={'flex'}
                flexDirection={'row'}
                justifyContent={'flex-start !important'}
              >
                <Button
                  ref={cancelRef}
                  _active={{ bg: '#FFF' }}
                  _focus={{ boxShadow: 'none' }}
                  _hover={{ bg: '#FFF' }}
                  bg={'#FFF'}
                  border={'1px solid #DB580B'}
                  color={'#DB580B'}
                  width={'100%'}
                  onClick={onClose}
                >
                  Cancelar
                </Button>
                <Button
                  marginTop={'0rem'}
                  ml={3}
                  variant={'btn-quilmes'}
                  width={'100%'}
                  onClick={() => deleteElement()}
                >
                  Eliminar
                </Button>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>
        : <Modal isOpen={isOpen} size={size} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader
              marginTop={'1rem'}
            >Eliminar embotelladora</ModalHeader>
            <ModalBody>
              <Text marginTop={'-.5rem'}>Se eliminará esta embotelladora definitivamente.</Text>
            </ModalBody>
            <ModalFooter>
              <Button
                ref={cancelRef}
                _active={{ bg: '#FFF' }}
                _focus={{ boxShadow: 'none' }}
                _hover={{ bg: '#FFF' }}
                bg={'#FFF'}
                border={'1px solid #DB580B'}
                color={'#DB580B'}
                marginBottom={'1rem'}
                width={'100%'}
                onClick={onClose}
              >
                Cancelar
              </Button>
              <Button
                marginBottom={'1rem'}
                marginTop={'0rem'}
                ml={3}
                variant={'btn-quilmes'}
                width={'100%'}
                onClick={() => deleteElement()}
              >
                Eliminar
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      }

      {success &&
            toast(
              () => (
                <Flex>
                  <Text >{success}</Text>
                </Flex>
              ),
              { id: 'successId' }
            )}
      <Toaster
        position={'bottom-center'}
        toastOptions={{
          duration: 2000,
          style: {
            color: '#FFFFFF',
            backgroundColor: '#3B3939'
          }
        }}
      />
    </Stack>
  )
}

export default BottlerManagement
